import { render } from "./IdentityVerificationLevel3.vue?vue&type=template&id=358ee8a8&scoped=true"
import script from "./IdentityVerificationLevel3.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationLevel3.vue?vue&type=script&lang=js"

import "./IdentityVerificationLevel3.vue?vue&type=style&index=0&id=358ee8a8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358ee8a8"]])

export default __exports__